// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TIKTOK_UNABLE_TO_LOAD_TIKTOK_VIDEO = "Nepoda\u0159ilo se na\u010d\u00edst TikTok video.";
export const TIKTOK_VIEW_ON_TIKTOK = "Zobrazit na TikTok";
